import BenchlingConfig from 'BenchlingConfig';
import {ModelHubEnablementState} from 'graphql-client/__generated/graphqlGlobalTypes';

export {ModelHubEnablementState};

export function isScientificAIModelsSectionVisible(): boolean {
  return BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED;
}

export function canRunScientificAIviaTAC(): boolean {
  if (!BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED) {
    return true;
  }
  return BenchlingConfig.MODEL_HUB_SCIENTIFIC_AI_USER_TAC_ENABLED;
}

export function getScientificAIDisabledMessage(): string | null {
  if (canRunScientificAIviaTAC()) {
    return null;
  }
  return 'You do not have permission to run Scientific AI models. Ask your tenant admin for access.';
}

export function canInstallScientificAIModels(): boolean {
  if (!BenchlingConfig.MODEL_HUB_TAC_PERMISSIONS_ENABLED) {
    return false;
  }
  return (
    BenchlingConfig.MODEL_HUB_SCIENTIFIC_AI_ENABLEMENT_STATE !== ModelHubEnablementState.AVAILABLE_DISABLED
  );
}

export function getScientificAIInstallBlockedMessage(): string | null {
  if (canInstallScientificAIModels()) {
    return null;
  }
  return 'Scientific AI models are not enabled for this tenant.';
}
